interface ErrorStateProps {
  error: Error;
}

export const ErrorState = ({ error }: ErrorStateProps) => (
  <div className="flex flex-1 items-center justify-center p-6 text-red-500">
    Error loading data: {error.message}
  </div>
);
